import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';

@Component({
  selector: 'app-hideable-facet-block',
  templateUrl: './hideable-facet-block.component.html',
  styleUrls: ['./hideable-facet-block.component.scss']
})
export class HideableFacetBlockComponent implements OnInit, OnDestroy, OnChanges {

  @Output() isOpenState = new BehaviorSubject<boolean>(false);

  @Output() selectionFilterSync = new EventEmitter<boolean>();

  @Input() showFacets = false;

  @Input() sortActive: boolean = false;

  showFilters = true;

  showLibs = true;

  isOpenStateSubscription: Subscription;

  constructor() {
  }

  ngOnInit() {
    this.isOpenStateSubscription = this.isOpenState.subscribe(show => {
      this.showFilters = show;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isOpenState.next(this.showFacets);
  }

  ngOnDestroy(): void {
    if (this.isOpenStateSubscription) {
      this.isOpenStateSubscription.unsubscribe();
    }
  }

  toggleFilter() {
    //this.isOpenState.next(!this.isOpenState.value);
    this.showFacets = !this.showFacets;
    this.selectionFilterSync.emit(this.showFacets);
  }
}
